import api from '@/modules/axios'
import apiHelperParams from '@/modules/apiHelperParams'
import apiHelperParamsJson from '@/modules/apiHelperParamsJson'

export default {
    selectBranch(params) {
        return api.post(process.env.VUE_APP_URL_MAIM, apiHelperParams('select-branch', params))
    },
    call(params) {
        return api.post(process.env.VUE_APP_URL_MAIM, apiHelperParams('call', params))
    },
    callDeferred(params) {
        return api.post(process.env.VUE_APP_URL_MAIM, apiHelperParams('call-deferred', params))
    },
    /*  scenarioOperation(params) {
     return api.post(process.env.VUE_APP_URL_MAIM, apiHelperParams('scenario-operation', params))
 },*/
    scenarioOperation(params) {
        return api.post(
            'scenario/operation',
            { ...apiHelperParamsJson(params, 'post').data },
            { headers: apiHelperParamsJson(params, 'post').headers }
        )
    },
    /**
     * Установка флага просмотра гостем других вкладок браузера
     * @param uuid
     * @param not_browsing
     * @return {boolean}
     */
    updateBrowsingOtherTab(not_browsing) {
        return api.post(
            '/guest/browsing-other-tab',
            { ...apiHelperParamsJson({ not_browsing }, 'post').data },
            { headers: apiHelperParamsJson({ not_browsing }, 'post').headers }
        )
    },
    articleAnswer(answer) {
        return api.post(
            '/chat/article-answer',
            { ...apiHelperParamsJson({ answer }, 'post').data },
            { headers: apiHelperParamsJson({ answer }, 'post').headers }
        )
    },
    articleHelped(answer) {
        return api.post(
            '/chat/article-helped',
            { ...apiHelperParamsJson({ answer }, 'post').data },
            { headers: apiHelperParamsJson({ answer }, 'post').headers }
        )
    }
}
